module.exports = __webpack_public_path__ + "img/1.4c6e0358.jpg";